var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.858,
    height: 9.542,
    viewBox: "0 0 6.858 9.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sort_icon",
    "data-name": "Sort Icon",
    d: "M1.768,9.542h5.7a.576.576,0,0,1,.407.983L5.027,13.377a.573.573,0,0,1-.813,0L1.36,10.525A.576.576,0,0,1,1.768,9.542ZM7.88,7.026,5.027,4.173a.573.573,0,0,0-.813,0L1.36,7.026a.576.576,0,0,0,.407.983h5.7A.576.576,0,0,0,7.88,7.026Z",
    transform: "translate(-1.191 -4.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.e6898dc0799204cdca598e1a7e9d55a9.svg";
export { ForwardRef as ReactComponent };